const sentinelRouter = [
    {
        path: "list-sentinel",
        name: "sentinel",
        component: () => import("@/views/admin/sentinel"),
        default: true,
        meta: {
            model: "kind",
            // requiresAuth: true,
        },
    },
    {
        path: "list-sentinel/add",
        name: "addSentinel",
        component: () => import("@/views/admin/sentinel/function"),
        default: true,
        meta: {
            model: "kind",
            // requiresAuth: true,
        },
    },
    {
        path: "list-sentinel/edit/:id",
        name: "editSentinel",
        component: () => import("@/views/admin/sentinel/function"),
        default: true,
        meta: {
            model: "kind",
            // requiresAuth: true,
        },
    },
];
export default sentinelRouter;